// 申請状況照会のラベル
export const LABELS = {
  EMPTY: "　",
  MERCHANTS_LIST: "加盟店一覧",
  STORE_LIST: "店舗一覧",
  SERVICE_NAME: "サービス名",
  CONTRACT_ROUTE: "契約ルート",
  CONTRACT_TYPE: "契約形態",
  ALL: "ALL",
  CONTRACT_DIRECTLY: "直接",
  CONTRACT_COMPREHENSIVE: "包括",
  CORPORATE_NUMBER: "法人番号",
  DUNS_NO: "DUNSナンバー",
  COMPANY_NAME: "事業者名",
  CONTRACT_SERVICE: "契約サービス",
  MERCHANTS_NAME: "加盟店名",
  MERCHANTS_TYPE: "加盟店種別",
  STORE_NAME: "店舗名",
  SHOP_CODE: "店舗コード",
  BUSINESS_CODE: "企業コード",
  IPID: "IPID",
  SITE_ID: "サイトID",
  EXCLUDE_CANCELED: "契約中のみ",
  STATUS: "ステータス",
  IN_CONTRACT: "契約中",
  CANCELLATION: "解約",
  OTHER: "その他",
  DETAIL_SEARCH: "詳細検索",
  MERCHANT_MANAGEMENT_NUMBER: "加盟店管理番号（包括）",
  QR_PRESENTATION_CATEGORY: "QR提示区分",
  INDUSTRY: "業態",
  SHOP_ID: "ショップID",
  CREDIT_CARD_ORDER_TARGET: "クレカ依頼先",
  CREDIT_CARD_MERCHANT_NUMBER: "クレカ加盟店番号",
  TERMINAL_IDENTIFICATION_NUMBER: "端末識別番号",
  // Orange項目追加
  //  決済グループID
  SETTLEMENT_GROUP_ID: "決済グループID",
  //  Access Key
  ACCESS_KEY: "Access Key",
  //  Secret Key
  SECRET_KEY: "Secret Key",
  GW_COMPANY: "ゲートウェイ",
  REGISTERED_COMPANY_CORPORATE_NUMBER: "登録事業者 法人番号",
  REGISTERED_COMPANY_COMPANY_NAME: "登録事業者名",
} as const;

/**　定数 */
export const STATUS = "status";
export const CORPORATE_NUMBER = "corporateNumber";
export const DUNS_NO = "dunsNo";
export const COMPANY_NAME = "companyName";
export const CONTRACT_SERVICE = "contractService";
export const MERCHANTS_TYPE = "merchantsType";
export const MERCHANTS_NAME = "merchantsName";
export const CONTRACT_TYPE = "contractType";
export const CONTRACT_ROUTE = "contractRoute";
export const QR_PRESENTATION_CATEGORY = "qrPresentationCategory";
export const IPID = "ipid";
export const SITE_ID = "siteId";
export const MERCHANT_MANAGEMENT_NUMBER = "merchantManagementNumber";
export const SHOP_ID = "shopId";
export const TERMINAL_IDENTIFICATION_NUMBER = "terminalIdentificationNumber";
// Orange項目追加
//  決済グループID
export const SETTLEMENT_GROUP_ID = "settlementGroupId";
//  Access Key
export const ACCESS_KEY = "accessKey";
//  Secret Key
export const SECRET_KEY = "secretKey";

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 10;

// プレースホルダーの内容
export const PLACE_APPLICATION = {
  DATE_FORMAT: "YYYY/MM/DD",
  FONT_SIZE: "30文字以内",
  FONT_SIZE_MERCHANTS: "100文字以内",
  TEXT_DIGITS_9: "半角数字9桁以内",
  TEXT_DIGITS_11: "半角数字11桁以内",
  TEXT_DIGITS_13: "半角数字13桁以内",
  TEXT_DIGITS_20: "半角英数字20桁以内",
  TEXT_DIGITS_30: "半角数字30桁以内",
  // Orange項目追加
  //  決済グループID・Access Key
  TEXT_DIGITS_26: "半角英数字26文字以内",
  TEXT_DIGITS_15: "15文字以内",
  TEXT_DIGITS_100: "100文字以内",
} as const;

// SELECTの空行の定義
export const SELECT_BLANK = { label: "　　　　　　", value: "" };

export const QR_PRESENTATION_CATEGORY_ITEMS = [
  { label: "　　　　", value: "" },
  { label: "CPM", value: "1" },
  { label: "MPM", value: "2" },
  { label: "加盟店QR", value: "3" },
];

export const CREDIT_CARD_ORDER_TARGET_ITEMS = [
  { label: "　　　　", value: "" },
  { label: "SMCC", value: "1" },
  { label: "セゾン", value: "2" },
  { label: "TOYOTA", value: "3" },
  { label: "JCB", value: "4" },
  { label: "AMEX", value: "5" },
  { label: "GMO", value: "6" },
  { label: "NTTF", value: "7" },
];
